import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-address-book-address-fields',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  template: `
    <fieldset [formGroup]="group">
      <legend>{{ legend }}</legend>
      <div class="address-grid">
        <mat-form-field appearance="outline"><mat-label>Straße</mat-label><input matInput formControlName="street" maxlength="255"></mat-form-field>
        <mat-form-field appearance="outline"><mat-label>Hausnummer</mat-label><input matInput formControlName="houseNumber" maxlength="64"></mat-form-field>
        <mat-form-field appearance="outline"><mat-label>Postleitzahl</mat-label><input matInput formControlName="postalCode" maxlength="64"></mat-form-field>
        <mat-form-field appearance="outline"><mat-label>Ort</mat-label><input matInput formControlName="city" maxlength="255"></mat-form-field>
        <mat-form-field appearance="outline"><mat-label>Bundesland / Region</mat-label><input matInput formControlName="state" maxlength="255"></mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Land (ISO-Code)</mat-label>
          <input matInput formControlName="countryCode" maxlength="2" placeholder="DE">
          <mat-hint>ISO 3166-1, z. B. DE</mat-hint>
          @if (group.controls['countryCode'].hasError('pattern')) { <mat-error>Zwei Buchstaben erforderlich.</mat-error> }
        </mat-form-field>
      </div>
      @if (group.touched && group.hasError('incompleteAddress')) {
        <p class="address-error" role="alert">Straße, Hausnummer, Postleitzahl und Ort sind gemeinsam erforderlich.</p>
      }
    </fieldset>
  `,
  styles: [`
    fieldset { margin: 0; padding: 1rem 1rem 0; border: 1px solid rgba(100, 116, 139, .25); border-radius: .7rem; }
    legend { padding: 0 .4rem; color: var(--app-surface-light, #64748b); font-size: .82rem; font-weight: 600; }
    .address-grid { display: grid; grid-template-columns: 2fr 1fr; gap: 0 .75rem; }
    mat-form-field { width: 100%; }
    .address-error { margin: -.5rem 0 1rem; color: #b91c1c; font-size: .78rem; }
    @media (max-width: 620px) { .address-grid { grid-template-columns: 1fr; } }
  `]
})
export class AddressBookAddressFieldsComponent {
  @Input({ required: true }) group!: FormGroup;
  @Input() legend = 'Adresse';
}
